// extracted by mini-css-extract-plugin
module.exports = {"container":"tokenField__container___1UXRQ","tokenField":"tokenField__tokenField___1I2ru","input":"tokenField__input___3Gyda","label":"tokenField__label___OqQsM"};